var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAsterisk = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M8.6,17.2V2" }),
                React.createElement("path", { d: "M2,13.4l13.2-7.6" }),
                React.createElement("path", { d: "M15.2,13.4L2,5.8" }),
                React.createElement("g", { transform: "translate(11.437 10.043) rotate(45)" },
                    React.createElement("path", { d: "M-0.9,3.1c-0.8,0.8-2,0.8-2.7,0s-0.8-2,0-2.7c0.8-0.8,2-0.8,2.7,0C-0.1,1.1-0.1,2.4-0.9,3.1 C-0.9,3.1-0.9,3.1-0.9,3.1z" }))))));
});
export default IconAsterisk;
//# sourceMappingURL=IconAsterisk.js.map